import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material';

import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { ConfirmationDialogData } from './confirmation-dialog.data';

@Component({
    selector : 'confirmation-dialog',
    template: require('./confirmation-dialog.component.html'),
    styles: [require('./confirmation-dialog.component.scss')]
})
export class ConfirmationDialogComponent implements OnInit {
    public text = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: ConfirmationDialogData,
        private translatePipe: TranslatePipe) {
    }

    public async ngOnInit() {
        const template = await this.translatePipe.transform('CONFIRM_DIALOG');
        if (this.data.message) {
            this.text = this.data.message;
        } else {
            this.text = typeof template === 'string' && template
                .replace('%action', this.data.action)
                .replace('%objType', this.data.objectType || '')
                .replace('%item', this.data.item || '');
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/components/dialogs/confirmation-dialog/confirmation-dialog.component.ts